import React from "react";
import { motion, useScroll } from "framer-motion";

// Neon yellow reading progress bar pinned to the top of the viewport.
// Using raw scrollYProgress (no spring) — GPU-only transform, zero scroll-time JS cost.
export const ReadingProgress = () => {
    const { scrollYProgress } = useScroll();
    return (
        <motion.div
            data-testid="reading-progress-bar"
            style={{ scaleX: scrollYProgress, transformOrigin: "0% 50%" }}
            className="fixed top-0 left-0 right-0 h-[3px] bg-[#FFD000] z-[60] will-change-transform"
        />
    );
};
